// extracted by mini-css-extract-plugin
module.exports = {"label":"AdminRadio_label__v-uVA","radio":"AdminRadio_radio__2G6Ju"};